import { SourceSystem } from '@signal/asp-data-commons';
import _ from 'lodash';

function objectTransform(dataYearArr, tempKey1, tempKey2, groupFactor) {
  let yearDataArr = []
  let testKeys = getDetailKeys(dataYearArr);
  testKeys.forEach(key => {
    let dt = _.groupBy(dataYearArr[key], groupFactor);
    let tempOBJ = {
      [tempKey1]: key,
      [tempKey2]: dt
    };
    yearDataArr.push(tempOBJ);
  })
  return yearDataArr;
}

function objectTransformOnTrimMarketingTitle(dataYearArr, tempKey1, tempKey2, groupFactor) {
  let dataArr = []
  let keys = getDetailKeys(dataYearArr);
  keys.forEach(key => {
    let groupedRes = _.groupBy(dataYearArr[key], groupFactor);
    let finalRes = convertEntriesOnMarketingTitle(groupedRes);
    let tempOBJ = {
      [tempKey1]: key,
      [tempKey2]: finalRes
    };
    dataArr.push(tempOBJ);
  })
  return dataArr;
}

function convertEntriesOnMarketingTitle(data) {
  let tObj = {}
  for(const [key,val] of Object.entries(data)){
    let ans = _.groupBy(val,"marketingTitle");
    let keys = getDetailKeys(ans);
    keys.forEach((key)=>{
      let keyName = ans[key][0].trim+"$%$"+key;
      tObj[keyName] = ans[key];
    })
  }
  return tObj;
}

export const getAllvehicles = (vehicles: any) => {
  if (Array.isArray(vehicles)) {
    const v1:any = [...vehicles];
    v1.sort((v1, v2) => v1?.model?.localeCompare(v2?.model))
    const data = _.groupBy(v1, 'model');
    const keys: string[] = getDetailKeys(data);
    const vehicleData = [];
    keys.forEach(key => {
      vehicleData.push({ key, value: data[key] })
    });
    return vehicleData;
  }
  else {
    return [];
  }
}

export const getVehiclesMake = (vehicles: any) => {
  const obj:any = {};
  obj.makeList = Object.keys(_.groupBy(vehicles, 'make'));
  obj.modelList = _.groupBy(vehicles, 'make');
  obj.allVehiclesCount = vehicles?.length || 0;
  return obj
}

export const transformVehicleInventory = (vehicles:  any, isAllVehicles) => {
  let filteredOnlineVehicles = Array.isArray(vehicles) ? (isAllVehicles ? vehicles.filter(d=> d.status === true): 
  vehicles.filter(d=> d.status === true && !d.expiredAt)): [];
  let dataYearArr = _.groupBy(filteredOnlineVehicles, 'year')
  let yearDataFinal = objectTransform(dataYearArr, "year", "series_List", "model")
  
  yearDataFinal.forEach((data)=>{
    data.series_List = objectTransformOnTrimMarketingTitle(data.series_List, "model", "trims", "trim")
  })

  return yearDataFinal;
}

export const getDetailKeys = (vehicles: any) => {
  if (vehicles) {
    return Object.keys(vehicles);
  }
  return [];
}

export const formatDeleteResponse = (response:any) => {
  if(response) {
    return _.groupBy(response, 'vin');
  }
  return [];
}

export const findOnlineVehicleCount = (allVehicles: any) => {
  let totalOnlineVehicle = Array.isArray(allVehicles)?allVehicles.filter(d => d.status && !d.expiredAt):null;
  return totalOnlineVehicle;
}

export const getFilteredVehicles = (vehicles, searchConfig, view) => {
  let filteredVehicle = vehicles?.filter(v => (v?.marketingName ? v.marketingName.toLowerCase().includes(searchConfig.modelFilter.toLowerCase()) : v?.model.toLowerCase().includes(searchConfig.modelFilter.toLowerCase()))
    && (searchConfig.statusFilter ? (searchConfig.statusFilter === 'deletePending' ? (v?.expiredAt && v?.nextTestDriveDate) : (v.status.toString().includes(searchConfig.statusFilter) && !v.expiredAt)) :
      v.status?.toString().includes(searchConfig.statusFilter))
    && v.year?.toString().includes(searchConfig.yearFilter)
    && v.make.toLowerCase().includes(searchConfig.makeFilter.toLowerCase())
    && v.vin.toLowerCase().includes(searchConfig.vinFilter.toLowerCase()))

  filteredVehicle = searchConfig.nextTestDriveDateFilter ? filteredVehicle.filter(v => v.nextTestDriveDate === searchConfig.nextTestDriveDateFilter) : filteredVehicle;
  filteredVehicle = searchConfig.licensePlateFilter ? filteredVehicle.filter(v => view === SourceSystem.ME ? v?.licensePlate?.toLowerCase()?.includes(searchConfig.licensePlateFilter.toLowerCase()) :
    v?.stockNo?.toLowerCase()?.includes(searchConfig.licensePlateFilter.toLowerCase())) : filteredVehicle;

  return filteredVehicle;
}